import { realizacaoProva } from './realizacaoProva';
import { logs } from './logs';
import { monitoramentoProva } from './monitoramentoProva';

export const relatorio = [
  ...realizacaoProva,
  ...logs,
  ...monitoramentoProva
];


// WEBPACK FOOTER //
// ./src/routes/prova/relatorio/index.js